
import fetch from './fetch.js'
//获取课程详情
export function api_home_getHomeContent(data) {
    return fetch({
        url: '/NewsManage/NewsShow/getHomeContent',
        method: 'get',
        params: data
    })
}
//获取各个项目的轮播图
export function api_home_getJobConfig(data) {
    return fetch({
        url: '/NewsManage/NewsShow/getJobConfig',
        method: 'post',
        params: data
    })
}
//获取各个项目的列表
export function api_home_getJobList(data) {
    return fetch({
        url: '/api/content/list',
        method: 'post',
        data: data
    })
}
//获取各个项目的详情
export function api_home_getJobInfo(data) {
    return fetch({
        url: '/api/content/detail',
        method: 'post',
        data: data
    })
}

//电话留言
export function api_home_postPhone(data) {
    return fetch({
        url: 'api/diy/telephone/add',
        method: 'post',
        data: data
    })
}
//信息留言
export function api_home_postMessage(data) {
    return fetch({
        url: 'api/message/add',
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js